import { InventoryBulkPriceRepository } from '@lib/api/repository/inventory-bulk-price/inventory-bulk-price.repository';

import { Requester } from '../clients';

export default class InventoryBulkPriceAPI implements InventoryBulkPriceRepository {
  async getBulkPricePreview(
    filters: import('@lib/types').BulkPriceUpdateFilter,
    action: import('@lib/types').BulkPriceUpdateAction,
  ) {
    const response = (
      await Requester.post<import('@lib/types').BulkPricePreview>(
        '/marketplace/inventory/bulk-price/preview',
        {
          body: {
            filters: {
              collectionId: filters.collectionId,
              cardId: filters.cardId,
              printingId: filters.printingId,
              rarityId: filters.rarityId,
              languageId: filters.languageId,
              condition: filters.condition,
              status: filters.status,
              search: filters.search,
              itemIds: filters.itemIds,
            },
            action: {
              adjustmentType: action.adjustmentType,
              adjustmentValue: action.adjustmentValue,
            },
          },
        },
      )
    ).data;

    return response;
  }

  async applyBulkPriceUpdate(
    filters: import('@lib/types').BulkPriceUpdateFilter,
    action: import('@lib/types').BulkPriceUpdateAction,
  ) {
    const response = (
      await Requester.post<import('@lib/types').BulkPriceApplyResult>(
        '/marketplace/inventory/bulk-price/apply',
        {
          body: {
            filters: {
              collectionId: filters.collectionId,
              cardId: filters.cardId,
              printingId: filters.printingId,
              rarityId: filters.rarityId,
              languageId: filters.languageId,
              condition: filters.condition,
              status: filters.status,
              search: filters.search,
              itemIds: filters.itemIds,
            },
            action: {
              adjustmentType: action.adjustmentType,
              adjustmentValue: action.adjustmentValue,
            },
          },
        },
      )
    ).data;

    return response;
  }
}
